import { ArrowLeft, X } from 'lucide-react';
import type { UseQueryResult } from '@tanstack/react-query';

import type { DropTimelineItem, DropTimelineResponse } from '@/hooks';
import { Button } from '@/components/ui';
import { Card, CardTitle } from '@/components/ui';
import type { DropTimelinePickTarget } from '@/features/siem/utils/drop-timeline';

import { DropTimelineModalTabs } from './DropTimelineModalTabs';
import { DropTimelinePickStep } from './DropTimelinePickStep';

export function DropTimelineModalCard(props: {
  subtitle: string;
  needsPick: boolean;
  pickList: DropTimelinePickTarget[];
  picked: DropTimelinePickTarget | null;
  setPicked: (t: DropTimelinePickTarget | null) => void;
  onClose: () => void;
  storyQ: UseQueryResult<DropTimelineResponse, Error>;
  fullQ: UseQueryResult<DropTimelineResponse, Error>;
  windowStory: string;
  windowFull: string;
  fullSiemLimit: number;
  onSelectItem: (item: DropTimelineItem) => void;
}) {
  const showBack = props.picked != null && props.pickList.length > 1;

  return (
    <div className="w-full max-w-2xl max-h-[90vh] flex flex-col min-h-0">
      <Card className="shadow-xl overflow-hidden flex flex-col min-h-0 max-h-[90vh]">
        <div className="flex shrink-0 items-start justify-between gap-3 border-b px-4 py-3">
          <div className="min-w-0">
            <CardTitle className="text-base">Drop timeline</CardTitle>
            <p className="text-xs text-muted-foreground mt-1">
              <span className="font-mono">{props.subtitle}</span>
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-1">
            {showBack ? (
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => props.setPicked(null)}
                aria-label="Back to drop list"
              >
                <ArrowLeft className="h-4 w-4" />
              </Button>
            ) : null}
            <Button variant="outline" size="sm" onClick={props.onClose} aria-label="Close">
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>

        <div className="overflow-y-auto min-h-0 px-4 py-3">
          {props.needsPick ? (
            <DropTimelinePickStep options={props.pickList} onSelect={props.setPicked} />
          ) : (
            <DropTimelineModalTabs
              storyQ={props.storyQ}
              fullQ={props.fullQ}
              windowStory={props.windowStory}
              windowFull={props.windowFull}
              fullLimit={props.fullSiemLimit}
              onSelectItem={props.onSelectItem}
            />
          )}
        </div>
      </Card>
    </div>
  );
}
